/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */

var FX = (function(FX, $) {


    /**
     * Doc Ready
     */
    $(function() {
        // TODO: Add Modules needed for build. Remove unused modules
        FX.Global.init();
        FX.MobileMenu.init();
        FX.SearchTrigger.init();
        FX.Slideshow.init();
        FX.ImAHuman.init();
        FX.Social.init();
        
        setTimeout(function() { $('.woocommerce-variation.single_variation.fx_single_variation_custom').show(); }, 500);
        
        $( 'input[name="phone-number"]' ).phoneFormat();
        $('#ship-to-different-address-checkbox').on('change', function() {
            if ($('#ship-to-different-address-checkbox').is(':checked')) {
                $('div.shipping_address').slideDown( 200 );
            }
            else {
                $('div.shipping_address').slideUp( 200 );
            }
        });
        $('#ship-to-different-address-checkbox').change();
        
        //Mailpoet redirect to thankyou page
        //From: https://gist.github.com/RafaelFunchal/519297c8a79cb5cd88d8
        $( '#mailpoet_form_1 form' ).on('submit', function(e){
            e.preventDefault();
            setTimeout(function() {
                var msg = $( '.mailpoet_validate_success' );
                if( msg.is(':visible') ){
                    window.location.href = '/contact-us/thank-you-newsletter/';
                }
            }, 3000);
        });
        
        $(".fx-catalog").on("click", function() {
            var catalog_link = $(this).children('img').first().attr('value');
            console.log("Viewing");
            if(catalog_link !== '' && catalog_link !== undefined) {
                console.log('Link set');
                console.log(catalog_link);
                if(window.mobilecheck()) {
                    window.open(catalog_link,'_blank');
                }
                else {
                    $('#issuu_viewer').empty();
                    $.featherlight('<iframe src="'+catalog_link+'" style="border:none;width:100%;height:100%;" title="issuu.com" allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen></iframe>');
                }
            }
            console.log("End viewing");
        });
        
        $('.fx_contact_tab').on('click', function() {
            //Hide all tabs
            $('.fx_contact_tab_contents').hide();
            $('.fx_contact_tab').removeClass('current');
            //Show desired tab
            var clickedTab = $(this);
            clickedTab.addClass('current');
            $('#'+clickedTab.attr('id')+'-content').show();
        });
        $('#contact_aps').click();
        
        $('.widget.fx_filter_by h3').on('click', function(e) {
            var $this = $(this);
            var $list = $this.siblings('ul').first();
            if($list.is(':visible')) {
                //Do nothing if it's already visible
                $list.slideUp(300);
                console.log('already visible, closing');
                return;
            }
            //Close any that are open
            $('.widget.fx_filter_by ul:visible').slideUp(300);
            //Reveal the filter options
            $list.slideDown(300);
        });
        jQuery('.widget.fx_filter_by ul').hide();
        
        var gaProperty = 'UA-45915440-1';
        var disableStr = 'ga-disable-' + gaProperty;
        if ( document.cookie.indexOf( disableStr + '=true' ) > -1 ) {
            window[disableStr] = true;
        }
        
        jQuery('.call-text a, .footer-phone, .click-to-call').click(function(){
            ga('send', 'event', 'Click to call', 'click', 'click to call');
            //Old, from version prior to adding the .click-to-call class
            //ga('send', 'event', 'Phone', 'click', 'click to call');
        });

    });



    $(window).load(function() {
        // TODO: Uncomment if using smooth scrolling anchors
        // FX.SmoothAnchors.init();

        /* Set Widget Footer to have the same height on large screen size */
        if (Modernizr.mq('(min-width: 1200px)')) {
            var highestBox = 0;

            $('.page-footer--main .widgets').each(function(){
                // If this box is higher than the cached highest then store it
                if($(this).height() > highestBox) {
                  highestBox = $(this).height(); 
                }    
            }); 

            $('.page-footer--main .widgets').each(function(){
                $(this).height(highestBox);
            }); 
        }
    });



    /**
     * Example Code Block - This should be removed
     * @type {Object}
     */
    FX.Global = {
    	init: function() {
            $('input').not('#ship-to-different-address-checkbox').iCheck({
                checkboxClass: 'icheckbox_minimal',
                radioClass: 'iradio_minimal',
                increaseArea: '20%' // optional
            });
    	}
    };
    
    
    /**
     * Mobile menu script for opening/closing menu and sub menus
     * @type {Object}
     */
    FX.MobileMenu = {
        init: function() {
            $('.nav-primary li.menu-item-has-children > a').after('<span class="sub-menu-toggle icon-chevron-thin-down hidden-md-up"></span>');

			$('.sub-menu-toggle').click( function() {
				var $this = $(this),
					$parent = $this.closest("li"),
					$wrap = $parent.find("> .sub-menu");
				$wrap.toggleClass("js-toggled");
				$this.toggleClass("js-toggled");
			});
        }
    };


    /**
     * Search Trigger
     * @type {Object}
     */
    FX.SearchTrigger = {
        init: function()
        {
            this.bind();
        },

        bind: function()
        {
            $('.search-trigger, .icon-search-mobile').on('click', this.toggleVisibility);
            $('#search-close').on('click', this.close);

        },

        toggleVisibility: function(event) {
            event.preventDefault();
            $('.search-trigger, .icon-search-mobile, #site-search-popup').toggleClass('js-active');
        },

        close: function(event) {
            event.preventDefault();
            $('.search-trigger, .icon-search-mobile, #site-search-popup').removeClass('js-active');
        }
    };



    /**
     * Slideshow settings (frontpage)
     * @type {Object}
     */
    FX.Slideshow = {
        init: function() {
            $('.slideshow').on('init', function(event, slick) {
                console.log('Slider initialized, unhide!');
                $('.slideshow .hide').removeClass('hide');
            });
            $('.slideshow').slick({
                infinite: true,
                speed: 1000,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: false,
                arrows: false,
                dots: true
            });

            $('.featured-products--list').slick({
                infinite: true,
                speed: 1000,
                slidesToShow: 3,
                autoplay: false,
                arrows: true,
                dots: false,
                centerPadding: '10px',
                responsive: [
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            centerMode: true
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true
                        }
                    }
                ]
            });

            $('.industries-list').slick({
                infinite: true,
                speed: 1000,
                slidesToShow: 1,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    },
                    {
                breakpoint: 769,
                settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                    }
                },
                {
                breakpoint:500,
                settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                    }
                }
                ]
            }); 

            $('.non-purchase-slider').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  asNavFor: '.slider-nav',
                   adaptiveHeight: true
                });
                
                if($('.non-purchase-slider').length != 0) {
                    $('.slider-nav').slick({
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      asNavFor: '.non-purchase-slider',
                      autoplay: false,
                      focusOnSelect: true,
                      arrows: false
                    });
                }

                $('.product-slider').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  asNavFor: '.slider-nav',
                   adaptiveHeight: true
                });
                
                if($('.product-slider').length != 0) {
                    $('.slider-nav').slick({
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      asNavFor: '.product-slider',
                      autoplay: false,
                      focusOnSelect: true,
                      arrows: false
                    });
                }
                
            } 


    };
    

    /**
     * Force External Links to open in new window.
     * @type {Object}
     */
    FX.ExternalLinks = {
        init: function() {
            var siteUrlBase = FX.siteurl.replace(/^https?:\/\/((w){3})?/,'')

            $('a[href*="//"]:not([href*="'+siteUrlBase+'"])')
                .not('.ignore-external') // ignore class for excluding
                .addClass('external')
                .attr('target', '_blank')
                .attr('rel', 'noopener');
        }
    };


    /**
     * Custom Social Share icons open windows
     * Generate URLs, place in a tag and use class - example: https://github.com/bradvin/social-share-urls
     * @type {Object}
     */
    FX.Social = {
        init: function() {
            $(".js-social-share").on("click", this.open);
        },

        open: function(event) {
          event.preventDefault();

          FX.Social.windowPopup($(this).attr("href"), 500, 300);
        },

        windowPopup: function (url, width, height) {
            var left = (screen.width / 2) - (width / 2),
                top = (screen.height / 2) - (height / 2);

            window.open(
                url,
                "",
                "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
            );
        }
    };

    /**
     * ImAHuman
     * Hidden Captchas for forms
     * @type {Object}
     */
    FX.ImAHuman = {
        num: "0xFF9481",
        forms: void 0,

        init: function() {
            this.setup();
        },

        setup: function() {
            this.forms = document.getElementsByTagName("form");
            this.bind();
        },

        bind: function() {
            for (var i = 0; this.forms.length > i; i++) {
                $(this.forms[i]).on("focus click", this.markAsHuman);
            }
        },

        markAsHuman: function() {
            $(this).find('.imahuman, [name="imahuman"]').attr("value", parseInt(FX.ImAHuman.num, 16));
        }
    };


    /**
     * Affix
     * Fixes sticky items on scroll
     * @type {Object}
     */
    FX.Affix = {
        windowHeight: 0,

        init: function() {
            this.windowHeight = $(window).height();
            this.bind();
        },

        bind: function(e) {
            $(window).on('scroll', this.scroll);
            $(window).on('resize', this.updateWindowHeight);
        },

        scroll: function(e) {
            var scrolltop = $(this).scrollTop(),
                fixPoint  = FX.Affix.windowHeight - $('#masthead').height();

            if(scrolltop >= fixPoint) {
                $('body').addClass('affix-head');
            } else {
                $('body').removeClass('affix-head');
            }
        },

        updateWindowHeight: function(e) {
            FX.Affix.windowHeight = $(window).height();
        }
    };



    /**
     * FX.Parallax
     * Parallax effect for images
     * @type {Object}
     */
    FX.Parallax = {
        init: function() {
            this.bind();
        },

        bind: function() {
            $(window).scroll(this.scroll);
        },

        scroll: function(e) {
            $('.js-parallax').each(function(){

                var $this   = $(this),
                    $speed  = $this.data('speed') || 6,
                    $window = $(window),
                    yPos    = -($window.scrollTop() / $speed),
                    coords  = 'center '+ yPos + 'px';

                $this.css({ backgroundPosition: coords });

            });
        }
    };



    /**
     * FX.SmoothAnchors
     * Smoothly Scroll to Anchor ID
     * @type {Object}
     */
    FX.SmoothAnchors = {
        init: function() {
            this.hash = window.location.hash;

            if ( this.hash != '' ) {
                this.scrollToSmooth(this.hash);
            }

            this.bind();
        },

        bind: function() {
            $('a[href^="#"]').on('click', $.proxy(this.onClick, this));
        },

        onClick: function(event) {
            event.preventDefault;

            var target = $(event.currentTarget).attr('href');

            this.scrollToSmooth(target);
        },

        scrollToSmooth: function(target) {
            var $target = $( target );
            $target = ($target.length) ? $target : $( this.hash );
            if ($target.length)
            {
                $('#page-header').addClass('js-fixed');
                var headerHeight = $('#page-header').outerHeight(true); // TODO: if using sticky header change 0 to
                                  // $('#page-header').outerHeight(true)
                var targetOffset = $target.offset().top - headerHeight - parseFloat($target.css('padding-top'));
                $('html,body').animate({scrollTop: targetOffset}, 600);

                return false;
            }
        }
    };



    /**
     * Tab Content
     * @type {Object}
     */
     
    /* HTML Formatting should follow this basic pattern:
    
    <ul class=“js-tabs”>
	    <li><a href=“#tab-content-1”>Tab</a></li>
	    <li><a href=“#tab-content-2”>Tab</a></li>
	</ul>
	
	<div id="tab-content-1">
	<!-- content -->
	</div>
	
	<div id="tab-content-2">
	<!-- content -->
	</div>
	*/

    FX.Tabs = {
        init: function() {
            $('.js-tabs').on('click touchstart', 'a', this.switchTab)
        },

        switchTab: function(event) {
            event.preventDefault();

            var $this = $(this),
                $tab  = $($this.attr('href'));

            $this.parent()
                 .addClass('active')
                 .siblings()
                 .removeClass('active');

            $tab.addClass('active')
                .siblings()
                .removeClass('active');
        }
    };

    /* Fixed Elements */
    $(window).scroll(function(){
        var headerFromTopPx = 1; // distance to trigger
        var headerScrolledFromtop = jQuery(window).scrollTop();
        if(headerScrolledFromtop > headerFromTopPx){
            jQuery('.page-header').addClass('js-fixed');
            jQuery('.site-main, .page-body').addClass('js-fixed');
        } else {
            jQuery('.page-header').removeClass('js-fixed');
            jQuery('.site-main, .page-body').removeClass('js-fixed');
        }    
        
        var backToTopFromTopPx = 500; // distance to trigger
        var backToTopScrolledFromtop = jQuery(window).scrollTop();
        if(backToTopScrolledFromtop > backToTopFromTopPx){
            jQuery('.back-to-top').addClass('js-scrolled');
        } else {
            jQuery('.back-to-top').removeClass('js-scrolled');
        }    
    });


/* Selectric */
    $(function() {
        $('select').not('.search_line .search_tags_container select').selectric();
        var obs = new MutationObserver(function(record, observer) {
            $('select').not('.search_line .search_tags_container select').selectric('refresh');
        })
        $('select').each(function() {
            obs.observe(this, {childList: true});
        });
    });

/* Mobile Menu Toggle */
    $('.menu-trigger').click( function() {
        $('.menu-trigger').toggleClass('active');
    });

/* Mainobile - Main Nav Toggles */

    $('.menu-trigger').click( function() {
        $('.nav-primary').toggleClass('active');
    });

/* Mobile - Subnav Menu Toggles */


    $('.sub-menu-toggle').click( function() {
        var $this = $(this),
            $parent = $this.parent("li"),
            $wrap = $parent.children(".sub-menu");
        $wrap.toggleClass("toggled");
        $parent.toggleClass("toggled");
        $this.toggleClass("toggled");
    });


$('.project-gallery').magnificPopup({
        delegate: 'a',
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
        },
        image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
                return '<h4 class="lb-title">' + item.el.attr('title') + '</h4>' + '<p class="lb-description">' + item.el.attr('data-description') + '</p>';
            }
        }
    });

    $( ".footer-products-block" ).on('click', function() { 
        $( ".menu-footer-widgets-products-container" ).toggleClass( "js-active" ); 
    });

    $( ".footer-planning-block" ).on('click', function() { 
        $( ".menu-footer-widgets-planning-tools-container" ).toggleClass( "js-active" ); 
    });

    $( ".footer-gallery-block" ).on('click', function() { 
        $( ".menu-footer-widgets-galleries-container" ).toggleClass( "js-active" ); 
    });

     $( ".footer-company-block" ).on('click', function() { 
        $( ".menu-footer-widgets-our-company-container" ).toggleClass( "js-active" ); 
    });



    return FX;
}(FX || {}, jQuery));

function gaOptout() {
    document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    window[disableStr] = true;
}